import gql from 'graphql-tag';
import fragments from '../fragments.js';

export default {
    resource({ fetchFullTranscripts }) {
        return gql`
            query Resource($url: String!) {
                resourceV2(url: $url) {
                    resource {
                        ... on ResourceProfileResponse {
                            profile {
                                ...ProfileFragment
                            }
                        }

                        ... on ResourcePostOnProfileResponse {
                            post {
                                ...PostFragment
                                ${fetchFullTranscripts ? '...PostFullTranscripts' : ''}
                            }
                        }

                        ... on ResourceCampaignContributionResponse {
                            id
                            promptText
                            termsText
                            privacyText
                            successText
                            successLink
                            successLinkLabel
                            successShareEnabled
                            enforcesTermsAndConditionsConsent
                            enforcesPrivacyPolicyConsent
                            contributionURL
                            hideBeamsBranding
                            status
                            color
                            backgroundColor
                            image {
                                ...ImageFragment
                            }
                            profile {
                                ...ProfileFragment
                            }
                            canAcceptResponses
                            privacyURL
                            termsURL
                            maximumRecordingDuration
                            backgroundImage {
                                ...ImageFragment
                            }
                            isNPSCampaign
                            NPSQuestion
                            promptSublineText
                            recordButtonLabel
                            isCSATCampaign
                            CSATQuestion
                            interfaceLanguage
                            privacyPolicyConsentText
                            termsAndConditionsConsentText
                            collectNames
                            collectEmails
                            collectImages
                            conversationalSurvey
                            newRecorder
                            agentWelcomeMessage
                            textFieldDefault
                        }
                    }
                }
            }
            ${fragments.post}
            ${fragments.profile}
            ${fragments.image}
            ${fragments.audio}
            ${fetchFullTranscripts ? fragments.postFullTranscripts : ''}
        `;
    },
};
